var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSwayIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  focusable: "false",
  viewBox: "0 0 64 64"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".SwayIcon-1{fill:currentColor;}.SwayIcon-2{fill:#36a7cd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "SwayIcon-1",
  d: "M47.84,26.11l-7.39-7.39v4.89l4.95,4.95c.94,.94,1.46,2.2,1.46,3.53s-.52,2.59-1.46,3.53l-21.81,21.81v4.89l24.25-24.25c1.6-1.6,2.47-3.72,2.47-5.97s-.88-4.38-2.47-5.97Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "SwayIcon-1",
  d: "M23.58,40.46l-4.98-4.98c-.94-.94-1.46-2.2-1.46-3.53s.52-2.59,1.46-3.53L40.44,6.58V1.69L16.16,25.98c-1.6,1.6-2.47,3.72-2.47,5.97s.88,4.38,2.47,5.97l7.42,7.42v-4.89Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "SwayIcon-1",
  d: "M26.56,24.47h13.02v13.02c0,1.08-.87,1.95-1.95,1.95h-13.02v-13.02c0-1.08,.87-1.95,1.95-1.95Z",
  transform: "translate(-13.19 32.05) rotate(-45)"
}), /*#__PURE__*/React.createElement("path", {
  className: "SwayIcon-2",
  d: "M41.3,33.33l-4.6,4.6-4.6,4.6-4.6-4.6-4.6-4.6c-.38-.38-.57-.88-.57-1.38s.19-1,.57-1.38l4.6-4.6,4.6-4.6,4.6,4.6,4.6,4.6c.38,.38,.57,.88,.57,1.38s-.19,1-.57,1.38Z"
}))));
export default SvgSwayIcon;